export const NEWEST_SHARED_DEPS_CONFIG = "LATEST";

export const SHARED_IMPORTS = {
  [NEWEST_SHARED_DEPS_CONFIG]: {
    scripts: {
      imports: {
        vue: `/libs/shared/vue@3.5.24/dist/${process.env.GUAC_VUE_RUNTIME_LIB}`,
        "vue-router": "/libs/shared/vue-router@4.6.3/dist/vue-router.global.prod.js",
        vuetify: "/libs/shared/vuetify@3.10.9/dist/vuetify.min.js",
        pinia: "/libs/shared/pinia@3.0.4/dist/pinia.iife.prod.js",
        "vue-demi": "/libs/shared/vue-demi@0.14.7/lib/index.iife.js",
        autobahn: "/libs/shared/autobahn@22.11.1/lib/autobahn.js",
        "vue-i18n": "/libs/shared/vue-i18n@11.1.12/dist/vue-i18n.global.prod.js",
        "@getwell/guac-layout": `${process.env.GUAC_APPS_URL}/guac-layout/mf/index.js`,
      },
    },
    styles: ["/libs/shared/vuetify@3.10.9/dist/vuetify.min.css"],
  },
  "3": {
    scripts: {
      imports: {
        vue: `/libs/shared/vue@3.5.24/dist/${process.env.GUAC_VUE_RUNTIME_LIB}`,
        "vue-router": "/libs/shared/vue-router@4.6.3/dist/vue-router.global.prod.js",
        vuetify: "/libs/shared/vuetify@3.10.9/dist/vuetify.min.js",
        pinia: "/libs/shared/pinia@3.0.4/dist/pinia.iife.prod.js",
        "vue-demi": "/libs/shared/vue-demi@0.14.7/lib/index.iife.js",
        autobahn: "/libs/shared/autobahn@22.11.1/lib/autobahn.js",
        "vue-i18n": "/libs/shared/vue-i18n@11.1.12/dist/vue-i18n.global.prod.js",
        "@getwell/guac-layout": `${process.env.GUAC_APPS_URL}/guac-layout/mf/index.js`,
      },
    },
    styles: ["/libs/shared/vuetify@3.10.9/dist/vuetify.min.css"],
  },
  legacy: {
    scripts: {
      imports: {
        vue: `/libs/shared/vue@3.4.27/dist/${process.env.GUAC_VUE_RUNTIME_LIB}`,
        "vue-router": "/libs/shared/vue-router@4.3.2/dist/vue-router.global.prod.js",
        vuetify: "/libs/shared/vuetify@3.6.4/dist/vuetify.min.js",
        pinia: "/libs/shared/pinia@2.1.7/dist/pinia.iife.prod.js",
        "vue-demi": "/libs/shared/vue-demi@0.14.5/lib/index.iife.js",
        autobahn: "/libs/shared/autobahn@22.11.1/lib/autobahn.js",
        "vue-i18n": "/libs/shared/vue-i18n@9.14.2/dist/vue-i18n.global.prod.js",
        "@getwell/guac-layout": `${process.env.GUAC_APPS_URL}/guac-layout/mf/index.js`,
      },
    },
    styles: ["/libs/shared/vuetify@3.6.4/dist/vuetify.min.css"],
  },
};

/**
 * Different version keys can resolve to the same library set. Comparing the resolved set instead of
 * the key stops the shell from reloading the page to load byte-identical libraries.
 */
export const sharedDepsFingerprint = (version: string) =>
  JSON.stringify(SHARED_IMPORTS[version] ?? SHARED_IMPORTS.legacy);
